export enum FollowUpStudyHandlingType {
	Link = 1,
	Merge = 2,
}
